import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Typography, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './legal.css';

const PrivacyPolicy = () => {
    const navigate = useNavigate();
    const [showLicenses, setShowLicenses] = useState(false);

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            {/* <Button 
                startIcon={<ArrowBackIcon />} 
                onClick={() => navigate(-1)}
                sx={{ mb: 3, color: '#03a9f4', fontWeight: 600 }}
            >
                Back
            </Button> */}

            {showLicenses ? (
                // Third Party Software Licenses View
                <Box className="legal-section" sx={{ textAlign: 'left', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', p: 4, borderRadius: '8px' }}>
                    
                    <Typography paragraph sx={{ textAlign: 'center', mb: 5 }}>
                                            <strong>Third-Party Software Licenses</strong>
                                        </Typography>
                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        Use and declarations related to Third party software Libraries and Software:
                    </Typography>
                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        To enable a seamless browsing experience to our customers, we rely on using the third party libraries and software. These third party libraries and software are governed by their own usage policies, declarations and privacy policies. Your use of ReUrja.com website automatically mandates you to follow the terms and conditions, governing rules / regulations, declarations, privacy policies etc. applicable under these Third party libraries and software. You may find the details of these at the below listed links.
                    </Typography>

                    <Typography paragraph sx={{ textAlign: 'left',  mt: 2, mb: 2 }}>
                        Third party software libraries and/or components Terms, Privacy policies, license references:
                    </Typography>
                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
<Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
React – https://github.com/facebook/react/blob/main/LICENSE<br />
React DOM – https://github.com/facebook/react/blob/main/LICENSE<br />
React Router DOM – https://github.com/remix-run/react-router/blob/main/LICENSE.md<br />
Material UI (MUI) – https://mui.com/, https://mui.com/legal/<br />
Emotion – https://github.com/emotion-js/emotion/blob/main/LICENSE<br />
Axios – https://github.com/axios/axios/blob/v1.x/LICENSE<br />
Firebase – https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE<br />
React Firebase Hooks – https://github.com/CSFrequency/react-firebase-hooks/blob/master/LICENSE<br />
React Google reCAPTCHA – https://github.com/dozoisch/react-google-recaptcha/blob/master/LICENSE<br />
React DatePicker – https://github.com/Hacker0x01/react-datepicker/blob/main/LICENSE<br />
React Responsive Carousel – https://github.com/leandrowd/react-responsive-carousel/blob/master/LICENSE<br />
React Full Screen – https://github.com/snakesilk/react-fullscreen/blob/master/LICENSE<br />
React PDF Viewer – https://github.com/react-pdf-viewer/react-pdf-viewer/blob/master/LICENSE<br />
FFmpeg WASM – https://github.com/ffmpegwasm/ffmpeg.wasm/blob/main/LICENSE<br />
UUID – https://github.com/uuidjs/uuid/blob/main/LICENSE.md<br />
Browser Image Compression – https://github.com/Donaldcwl/browser-image-compression/blob/master/LICENSE<br />
date-fns – https://github.com/date-fns/date-fns/blob/main/LICENSE.md<br />
jsPDF – https://github.com/parallax/jsPDF/blob/master/LICENSE<br />
jsPDF AutoTable – https://github.com/simonbengtsson/jsPDF-AutoTable/blob/main/LICENSE.txt<br />
React Scripts – https://github.com/facebook/create-react-app/blob/main/LICENSE<br />
Web Vitals – https://github.com/GoogleChrome/web-vitals/blob/main/LICENSE<br />
Testing Library – https://github.com/testing-library/react-testing-library/blob/main/LICENSE<br />
CORS – https://github.com/expressjs/cors/blob/master/LICENSE<br />

React Quill – https://github.com/zenoamaro/react-quill/blob/master/LICENSE<br />
Lucide React – https://github.com/lucide-icons/lucide/blob/main/LICENSE<br />
Mammoth – https://github.com/mwilliamson/mammoth.js/blob/master/LICENSE<br />
SheetJS (xlsx) – https://github.com/SheetJS/sheetjs/blob/master/LICENSE<br />
PapaParse – https://github.com/mholt/PapaParse/blob/master/LICENSE<br />
</Typography>
                </Typography>
                </Box>
            ) : (
                // Privacy Policy View
                <Box className="legal-section" sx={{ textAlign: 'left', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', p: 4, borderRadius: '8px' }}>
                    <Typography paragraph sx={{ textAlign: 'center', mb: 5 }}>
                                            <strong>Privacy Policy</strong>
                                        </Typography>

                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        By using OmneVu.com website and services you agree to our use of your personal information (including sensitive personal information) in accordance with this Privacy Notice, as may be amended from time to time by us at our discretion. You also agree and consent to us collecting, storing, processing, transferring, and sharing your personal information (including sensitive personal information) with third parties or service providers for the purposes set out in this Privacy Notice.
                    </Typography>

                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        We may automatically collect and store certain types of information about your use of OmneVu.com and it's services, including information about your interaction with content and services available through OmneVu.com. We may use cookies and other unique identifiers, and we obtain certain types of information when your web browser or device accesses OmneVu.com and it's services and other content served by or on behalf of OmneVu.com on other websites.
                    </Typography>

                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        We might receive information about you from other sources, such as updated delivery and address information from our carriers, which we use to correct our records and deliver your next purchase more easily.
                    </Typography>

                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        We use your personal information to operate, provide, develop, and improve the products and services that we offer our customers. These purposes include:
                    </Typography>

                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        
                            We may use your personal information to take and fulfill orders, deliver products and services, process payments, and communicate with you about orders, products and services, and promotional offers.
                            We may use your personal information to provide functionality, analyze performance, fix errors, and improve the usability and effectiveness of the OmneVu.com Services.
                            We may use your personal information to recommend features, products, and services that might be of interest to you, identify your preferences, and personalize your experience with OmneVu.com / Services.
                            In certain cases, we may collect and use your personal information to comply with laws.
                            We may use your personal information to communicate with you in relation to OmneVu.com and it's associated product(s) and/or services via different channels (e.g., by phone, e-mail, chat).
                            We may use your personal information to display interest-based ads for features, products, and services that might be of interest to you.
                            We may use personal information to prevent and detect fraud and abuse in order to protect the security of our customers, OmneVu.com, and others.
                        
                    </Typography>

                    <Typography paragraph sx={{ textAlign: 'left', mb: 2 }}>
                        To enable our systems to recognize your browser or device and to provide and improve OmneVu.com Services, we use cookies and other identifiers.
                    </Typography>

                    <Typography paragraph sx={{ textAlign: 'left',  mt: 2, mb: 1 }}>
                        Third-Party Advertisers and Links to Other Websites:
                    </Typography>
                    <Typography paragraph sx={{ textAlign: 'left', mb: 3 }}>
                        OmneVu.com may include third-party advertising and links to other websites and apps. Third-party advertising partners may collect information about you when you interact with their content, advertising, and services.
                    </Typography>

                    <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: '4px', mb: 3 }}>
                        <Typography paragraph sx={{ textAlign: 'left' }}>
                            <Box component="span" onClick={() => setShowLicenses(true)} sx={{ cursor: 'pointer', color: '#000000', textDecoration: 'underline', fontWeight: 500 }}>
                                View our Third Party Software Licenses
                            </Box>
                        </Typography>
                    </Box>
                </Box>
            )}

            <Button 
                startIcon={<ArrowBackIcon />} 
                onClick={() => navigate(-1)}
                sx={{ mt: 4, mb: 2, color: '#03a9f4', fontWeight: 600 }}
            >
                Back
            </Button>
        </Container>
    );
};

export default PrivacyPolicy;
